/**
 * created by wang lei
 xxxxx页面
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from '../../../../../base/BaseComponent';
import {DatePicker, Radio} from 'antd';
import moment from "moment"

const {RangePicker} = DatePicker;

export default class Sta_Date extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            btnText: '今日',
            data: []
        }
    }



    componentWillMount() {
        let {config} = this.props;
        let {defaultKey, selectConfig} = config;
        this.state.btnText = defaultKey;
        this.state.data = selectConfig;
        this.showData(this.state.btnText);
        this.setState({})
    }


    render() {
        let {data} = this.state;
        return (
            <div style={{display: 'flex',flexWrap: "nowrap"}}>
                <Radio.Group value={this.state.btnText}
                    style={{ marginRight: '10px', display: "flex", flexWrap: "nowrap", whiteSpace: "nowrap" }} onChange={this.handleSizeChange}>
                    {data && data.length && data.map((item, index) => {
                        return (<Radio.Button value={item} key={index}>{item}</Radio.Button>)
                    })}
                </Radio.Group>
                <RangePicker getPopupContainer={triggerNode => triggerNode.parentNode} allowClear={this.props.allowClear}
                    disabledDate={this.props.disabledDate}
                    value={[this.state.start, this.state.end]}
                    onChange={this.rangePickerChange}
                    style={{ width: 230, marginRight: 20 }} />
            </div>
        )
    }

    handleSizeChange = e => {
        let data = e.target.value;
        this.showData(data)
    };


    showData = (data) => {
        const dayMatch = data.match(/^近(\d+)天$/);
        if (data === "今日"||data === "今天") {
            this.state.start = moment().day(moment().day()).startOf('day');
            this.state.end = moment().day(moment().day()).endOf('day');
        } else if (data === "昨日" || data === "昨天") {
            this.state.start = moment().day(moment().day() - 1).startOf('day');
            this.state.end = moment().day(moment().day() - 1).endOf('day');
        } else if(data === "前天"){
            this.state.start = moment().day(moment().day() - 2).startOf('day');
            this.state.end = moment().day(moment().day() - 2).endOf('day');
        }else if (data === "本周") {
            this.state.start = moment().week(moment().week()).startOf('week');
            this.state.end = moment().week(moment().week()).endOf('week');
        } else if (data === "本月") {
            this.state.start = moment().month(moment().month()).startOf('month');
            this.state.end = moment().month(moment().month()).endOf('month');
        } else if (data === "本年") {
            this.state.start = moment().year(moment().year()).startOf('year');
            this.state.end = moment().year(moment().year()).endOf('year');
        }else if(data === '近7天' || data === '近一周'){
            this.state.start = moment().add(-6, 'days').startOf('days');
            this.state.end = moment()
        }else if(data === '近15天'){
            this.state.start = moment().add(-14, 'days').startOf('days');
                this.state.end =moment()
        }else if(data === '近30天'){
            this.state.start =moment().add(-29, 'days').startOf('days');
                this.state.end =moment()
        }else if(data === '全部' || data === '时间不限'){
            this.state.start = null;
            this.state.end = null
        }else if (dayMatch) {
            const days = parseInt(dayMatch[1], 10);
            this.state.start = moment().subtract(days - 1, 'day').startOf('day');
            this.state.end = moment();
        }
        this.state.btnText = data;
        this.setState({},()=>{
            this.props.callBack&&this.props.callBack(this.state.start,this.state.end)
        });
    };

    revert = (text) =>{
        this.setState({btnText: text || "",start:null,end:null})
    };

    rangePickerChange = (data, dateString) => {
        let {config} = this.props;
        let {defaultKey} = config;
        let start = data && data[0] ? data[0].startOf('day') : null;
        let end = data && data[1] ? data[1].endOf('day') : null;
        this.setState({
            start, end
        },()=>{
            this.props.callBack&&this.props.callBack(this.state.start,this.state.end)
        });
        if (start === null) {
            this.setState({ btnText: defaultKey })
        } else {
            this.setState({ btnText: "" })
        }

    };
}